import React from 'react';
import { MenuItem, Menu, Button, Popover } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { SearchWrapper, FilterWrapper } from 'components/styled-components';
import isEqual from 'lodash/isEqual';
import shortid from 'shortid';

const RenderedFilters = ({
  handleChangeFilter,
  active,
  filter,
  filterField,
  displayFilter,
}) => {
  return (
    <MenuItem
      onClick={() => handleChangeFilter(filter, filterField, displayFilter)}
      text={filter.label}
      key={shortid.generate()}
      active={isEqual(filter, active)}
    />
  );
};

const RenderedFilterMenu = props => {
  return (
    <Menu>
      <MenuItem text="Clear Filters" onClick={props.clearFilters} />
      <MenuItem
        text="Question Type"
        active={props.activeParent === 'Question Type'}
      >
        {props.questionTypeFilters.map(filter => (
          <RenderedFilters
            filter={filter}
            {...props}
            filterField="questionType"
            displayFilter={`Question Type > ${filter.label}`}
            key={shortid.generate()}
          />
        ))}
      </MenuItem>
      <MenuItem
        text="Display Category"
        active={props.activeParent === 'Display Category'}
      >
        {props.displayCategoryFilters.map(filter => (
          <RenderedFilters
            filter={filter}
            {...props}
            filterField="displayCategory"
            displayFilter={`Display Category > ${filter.label}`}
            key={shortid.generate()}
          />
        ))}
      </MenuItem>
      <MenuItem text="Default" active={props.activeParent === 'Default'}>
        {props.defaultQuestionFilters.map(filter => (
          <RenderedFilters
            filter={filter}
            {...props}
            filterField="defaultQuestion"
            displayFilter={`Default > ${filter.label}`}
            key={shortid.generate()}
          />
        ))}
      </MenuItem>
    </Menu>
  );
};

const FilterMenu = ({
  categories,
  questionTypes,
  questionStatus,
  handleChangeFilter,
  selectedFilter,
  displayFilter,
  clearFilters,
}) => {
  const displayCategoryFilters = [];
  const questionTypeFilters = [];
  const statusFilters = [];
  const defaultQuestionFilters = [
    { label: 'All', value: null },
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];

  categories.forEach(filter => {
    displayCategoryFilters.push({
      label: filter.categoryName,
      value: filter.categoryID,
    });
  });
  questionTypes.forEach(filter => {
    questionTypeFilters.push({
      label: filter.typeName,
      value: filter.typeID,
    });
  });

  questionStatus.forEach(filter => {
    if (filter.statusName.toUpperCase() !== 'INACTIVE') {
      statusFilters.push({
        label: filter.statusName,
        value: filter.versionStatusID,
      });
    }
  });

  return (
    <SearchWrapper padding="0 1rem">
      <Popover
        content={
          <RenderedFilterMenu
            handleChangeFilter={handleChangeFilter}
            active={selectedFilter}
            activeParent={displayFilter}
            clearFilters={clearFilters}
            questionTypeFilters={questionTypeFilters}
            statusFilters={statusFilters}
            displayCategoryFilters={displayCategoryFilters}
            defaultQuestionFilters={defaultQuestionFilters}
          />
        }
        autoFocus={false}
      >
        <FilterWrapper>
          <Button
            icon={IconNames.FILTER_LIST}
            rightIcon="caret-down"
            text={displayFilter ? displayFilter : 'Filter'}
            className={`${
              displayFilter === '' ? 'light-blue' : 'filter-selected'
            }`}
            fill={true}
            alignText="left"
          />
        </FilterWrapper>
      </Popover>
    </SearchWrapper>
  );
};

export default FilterMenu;
